import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getCaseCredits = createAsyncThunk(
  'creditForCaseToCase/get',
  async (_, thunkAPI) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_creditForCaseToCase.get, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      });

      if (!response.ok) return thunkAPI.rejectWithValue('Failed to fetch case credits');
      return await response.json();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
